import { render, staticRenderFns } from "./course.vue?vue&type=template&id=850fce60&scoped=true"
import script from "./course.vue?vue&type=script&lang=ts"
export * from "./course.vue?vue&type=script&lang=ts"
import style0 from "./course.vue?vue&type=style&index=0&id=850fce60&prod&lang=scss&scoped=true"
import style1 from "./course.vue?vue&type=style&index=1&id=850fce60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850fce60",
  null
  
)

export default component.exports